import {
  FilterQuery,
  ParameterAndFilter,
  ParameterFilterOption,
  ParameterOrFilter,
} from "../../../../../../microservices/functions/src/types/product_catalog/catalog_api_types";

export const removePropertyFromFilter = (
  filter: FilterQuery,
  filterProperty: keyof FilterQuery
): FilterQuery => {
  const newFilter: FilterQuery = {
    ...filter,
  };
  delete newFilter[filterProperty];

  return newFilter;
};

export const removeValuesFromArray = <T>(
  array: T[] | undefined,
  valueToRemove: T
): T[] | undefined => {
  if (array === undefined) {
    return undefined;
  }

  const arrayWithoutValue = array.filter((value) => value !== valueToRemove);
  if (arrayWithoutValue.length > 0) {
    return arrayWithoutValue;
  } else {
    return undefined;
  }
};

export const removeTextParameterFilter = (
  parameterFilter: FilterQuery["parameters"],
  parameterId: number,
  valueIdToRemove: number
) => {
  const newParameterFilter: FilterQuery["parameters"] = {
    ...parameterFilter,
  };
  const previousValueIds = (newParameterFilter[parameterId] as
    | ParameterAndFilter
    | ParameterOrFilter).valueIds;
  newParameterFilter[parameterId] = {
    ...newParameterFilter[parameterId],
    valueIds: previousValueIds.filter(
      (previousValueId) => previousValueId !== valueIdToRemove
    ),
  } as ParameterAndFilter | ParameterOrFilter;

  return newParameterFilter;
};

export const removeRangeParameterFilter = (
  parameterFilter: FilterQuery["parameters"],
  id: number
) => {
  const newParameterFilter: FilterQuery["parameters"] = {
    ...parameterFilter,
  };
  delete newParameterFilter[id];

  return newParameterFilter;
};

export const removeBooleanParameterFilter = (
  parameterFilter: FilterQuery["booleanParameters"],
  id: number
) => {
  const newParameterFilter: FilterQuery["booleanParameters"] = {
    ...parameterFilter,
  };
  delete newParameterFilter[id];

  return newParameterFilter;
};
